const images = [
  {
    thumb: require("../../../assets/collection/classic/dab_black.jpg"),
    src: require("../../../assets/collection/classic/dab_black.jpg"),
    caption: "Dąb Black",
    srcset: require("../../../assets/collection/classic/dab_black.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/classic/dab_crudo.jpg"),
    src: require("../../../assets/collection/classic/dab_crudo.jpg"),
    caption: "Dąb Crudo",
    srcset: require("../../../assets/collection/classic/dab_crudo.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/dab_flamandzki.jpg"),
    src: require("../../../assets/collection/classic/dab_flamandzki.jpg"),
    caption: "Dąb Flamandzki",
    srcset: require("../../../assets/collection/classic/dab_flamandzki.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/dab_orzech.jpg"),
    src: require("../../../assets/collection/classic/dab_orzech.jpg"),
    caption: "Dąb Orzech",
    srcset: require("../../../assets/collection/classic/dab_orzech.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/dab_palacowy.jpg"),
    src: require("../../../assets/collection/classic/dab_palacowy.jpg"),
    caption: "Dąb Pałacowy",
    srcset: require("../../../assets/collection/classic/dab_palacowy.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/dab_toscania.jpg"),
    src: require("../../../assets/collection/classic/dab_toscania.jpg"),
    caption: "Dąb Toscania",
    srcset: require("../../../assets/collection/classic/dab_toscania.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/flamandzki.jpg"),
    src: require("../../../assets/collection/classic/flamandzki.jpg"),
    caption: "Flamandzki",
    srcset: require("../../../assets/collection/classic/flamandzki.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/lattea.jpg"),
    src: require("../../../assets/collection/classic/lattea.jpg"),
    caption: "Lattea",
    srcset: require("../../../assets/collection/classic/lattea.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/orzechowy.jpg"),
    src: require("../../../assets/collection/classic/orzechowy.jpg"),
    caption: "Orzechowy",
    srcset: require("../../../assets/collection/classic/orzechowy.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/palacowy.jpg"),
    src: require("../../../assets/collection/classic/palacowy.jpg"),
    caption: "Pałacowy",
    srcset: require("../../../assets/collection/classic/palacowy.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/royal.jpg"),
    src: require("../../../assets/collection/classic/royal.jpg"),
    caption: "Royal",
    srcset: require("../../../assets/collection/classic/royal.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/sycylia.jpg"),
    src: require("../../../assets/collection/classic/sycylia.jpg"),
    caption: "Sycylia",
    srcset: require("../../../assets/collection/classic/sycylia.jpg"),
    description: ""
  },

  {
    thumb: require("../../../assets/collection/classic/toscania.jpg"),
    src: require("../../../assets/collection/classic/toscania.jpg"),
    caption: "Toscania",
    srcset: require("../../../assets/collection/classic/toscania.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/classic/dab_may.jpg"),
    src: require("../../../assets/collection/classic/dab_may.jpg"),
    caption: "Dąb May",
    srcset: require("../../../assets/collection/classic/dab_may.jpg"),
    description: ""
  }
];

export default images;
